export default __webpack_public_path__ + "static/media/9-Participating-in-Bapa-Food-Fair-2019.d44f0f76.jpg";